import gql from 'graphql-tag';

export const UPDATE_BOOKING_PAYMENT = gql`
  mutation updateBookingPayment(
    $activityId: Int
    $accommodationId: Int
    $isPaid: Boolean
    $clientSecret: String
    $activityBookingId: Int
    $accommodationBookingId: Int
  ) {
    updateBookingPayment(
      activityId: $activityId
      accommodationId: $accommodationId
      isPaid: $isPaid
      clientSecret: $clientSecret
      activityBookingId: $activityBookingId
      accommodationBookingId: $accommodationBookingId
    ) {
      success
      update
    }
  }
`;

export const CANCEL_BOOKING_PAYMENT = gql`
  mutation cancelBookingPayment(
    $activityId: Int
    $accommodationId: Int
    $activityBookingId: Int
    $accommodationBookingId: Int
  ) {
    cancelBookingPayment(
      activityId: $activityId
      accommodationId: $accommodationId
      activityBookingId: $activityBookingId
      accommodationBookingId: $accommodationBookingId
    ) {
      status
    }
  }
`;
